import React from 'react';
import { DragLayer } from 'react-dnd';
import FSObjectIcon from 'components/event/FileSystem/FSObjectIcon';

import styled from 'styled-components';

const DragLayerWrapper = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 10000000000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const DraggedItem = styled.div`
  position: relative;
  display: flex;
  width: 200px;
  height: 48px;
  padding: 0 15px;
  border: 2px solid #526489;
  border-radius: 5px;
  background-color: #fff;
  z-index: 1001;
`;

const DraggedItemText = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 16px;
  font-weight: bold;
  color: #333;

  svg {
    font-size: 16px;
    margin-right: 6px;
    transform: translateY(-2px);
  }
`;

const StyledName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DraggedGroupItem = styled(DraggedItem)`
  position: absolute;
  z-index: 1000;
  opacity: 0.5;
`;
const DragCount = styled.div`
  position: absolute;
  top: -12px;
  right: -12px;
  color: #fff;
  background-color: #0095ff;
  font-size: 12px;
  border-radius: 20px;
  width: 24px;
  height: 24px;
  text-align: center;
  padding-top: 3px;
`;

const collect = monitor => {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging()
  };
};

const CustomDragLayer = props => {
  const { item, itemType, isDragging } = props;

  if (!isDragging) {
    return null;
  }

  return (
    <DragLayerWrapper>
      <div style={getItemStyles(props)}>
        {getLayerForItemType(itemType, item)}
      </div>
    </DragLayerWrapper>
  );
};

const getLayerForItemType = (type, item) => {
  switch (type) {
    case 'FSObject':
      let dragCount = 0;
      if (item.selectedItemIds) dragCount = item.selectedItemIds.length;
      return <FSObjectDragLayer item={item.item} dragCount={dragCount} />;
    default:
      return null;
  }
};

const FSObjectDragLayer = ({ item, dragCount }) => {
  let dragCountNode = null;

  if (dragCount && dragCount > 1) {
    dragCountNode = <DragCount>{dragCount}</DragCount>;
  }

  const groupedItemNodes = [];

  let i;
  for (i = 1; i < dragCount; i++) {
    groupedItemNodes.push(
      <DraggedGroupItem
        key={`${item._id}-${i}-drag-item`}
        style={{ top: i * 5, left: i * 5 }}
      />
    );
  }

  groupedItemNodes.reverse();

  return (
    <div style={{ position: 'relative' }}>
      <DraggedItem>
        <DraggedItemText>
          <FSObjectIcon item={item} />
          <StyledName>{item.name}</StyledName>
        </DraggedItemText>
        {dragCountNode}
      </DraggedItem>
      <div style={{ position: 'absolute', top: 0 }}>{groupedItemNodes}</div>
    </div>
  );
};

export const getItemStyles = props => {
  const { currentOffset } = props;
  if (!currentOffset) {
    return {
      display: 'none'
    };
  }

  const { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;

  return {
    transform: transform,
    WebkitTransform: transform
  };
};

export default DragLayer(collect)(CustomDragLayer);
